import React from 'react';
export function Guarantee() {
  return <section className="py-16 px-6 bg-gray-50" data-id="element-60">
      <div className="max-w-2xl mx-auto text-center" data-id="element-61">
        <div className="text-6xl mb-4" data-id="element-62">🛡️</div>
        <h2 className="text-2xl font-extrabold text-gray-900 mb-4" data-id="element-63">
          GARANTÍA PACK DE INGLÉS — 7 DÍAS
        </h2>
        <div className="text-left bg-white rounded-2xl p-6 shadow-sm mb-6 space-y-3" data-id="element-64">
          {['Abrís los 12 tomos.', 'Revisás los 6 bonus.', 'Los usás en el aula si querés.'].map(step => <div key={step} className="flex items-center gap-3 text-gray-700 text-sm" data-id="element-65">
              <span className="text-blue-600 font-bold" data-id="element-66">→</span>
              <span data-id="element-67">{step}</span>
            </div>)}
        </div>
        <div className="bg-blue-600 text-white rounded-2xl p-6" data-id="element-68">
          <p className="font-bold text-lg mb-2" data-id="element-69">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-blue-100 text-sm" data-id="element-70">
            Te devolvemos el 100%. Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="mt-4 text-sm text-blue-200" data-id="element-71">
            La confianza que tenemos en el Pack de Inglés nos permite ofrecerte
            eso. Más de 1.500 docentes ya lo saben.
          </p>
        </div>
      </div>
    </section>;
}